import React, {Component } from 'react';
import uuid from 'uuidv4'
import { actions as routerActions } from 'redux-router5'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import {LISTS, ERROR} from '../router/routes.js';
import CodeForm from './CodeForm'
import {Creators as ErrorActionCreators} from '../reducers/actions';


class CodeImpl extends Component {
  
  constructor(props) {
      super(props)
      this.secretCode = uuid().toString()
  }

  formSubmitted = (values) => {
    if (!values.isRobot || values.secret !== values.code)
    {
        this.props.setError(values.isRobot
          ? "You have not entered the correct code!"
          : "You are not a robot, go away!"
        )
        this.props.navigateTo(ERROR)
        return;
    }
    this.props.navigateTo(LISTS)
  }

  
  render() {
    return(
        <React.Fragment>
            <h3>Please enter the secret code</h3>
            <em>(well, not so secret, it is actually included in this page in a hidden input)</em>
            <CodeForm onSubmit={this.formSubmitted} initialValues={{secret:this.secretCode}}/>
        </React.Fragment>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  navigateTo: (route, params) => dispatch(routerActions.navigateTo(route, params)),
  setError: (errorMessage) => dispatch(ErrorActionCreators.setError(errorMessage)),
})

CodeImpl.propTypes = {
  navigateTo: PropTypes.func,
  setError: PropTypes.func,
};

export const Code = connect(null, mapDispatchToProps) (CodeImpl)

